import { useCallback } from 'react';

import { useAtomValue } from 'jotai';

import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { nlsToEvent } from '@tracking/Schemas/Nls/NlsToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

export const useNlsTracking = () => {
  const userId = useAtomValue(userIdAtom);
  const formState = useAtomValue(formStateAtom);

  const userData = { userId, values: { ...formState } };
  const userEvent = userContextToEvent(userData);

  const trackNlsQuery = useCallback(
    (query: string) => {
      const event = nlsToEvent({ query });
      trackCustomEvent({ event, context: [userEvent] });
    },
    [userId],
  );

  const trackNlsResult = useCallback(
    (query: string, resultUrl: string) => {
      const event = nlsToEvent({ query, resultUrl });
      trackCustomEvent({ event, context: [userEvent] });
    },
    [userId],
  );

  return { trackNlsQuery, trackNlsResult };
};
